import PropTypes from "prop-types";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { getErrorMessage } from "../form/FormStandardProps";
import Label from "./Label";

const TextInput = ({
  className = "",
  icon = "",
  iconPosition = "right",
  input,
  label = "",
  meta,
  placeholder = "",
  required = false,
  showPasswordFeedback = false,
  disabled = false,
  readOnly = false,
  infoMessage = "",
  infoPosition = "top",
  onChange, // ✅ capture custom onChange from parent Field
  ...rest
}) => {

 
  const { touched, error } = meta || {};

  const { type, ...inputProps } = input || {};

    if(type=="time"){
// console.log(value, "value of time i have recived");
  }

   // unified handler for all input types
  const handleChange = (e) => {
     const value = e.target.value;
    // const value = e?.target?.value ?? e ?? "";
    if (input?.onChange) input.onChange(value); // update form field value
    if (onChange) onChange(value); // call parent custom handler (e.g. setStartTime)
  };

  const getValue = () => {
    // if ('value' in rest) return rest.value;  // <- respect parent prop
    if (disabled && input.value) {
      return input.value;
    } else if (input.value) {
      return input.value;
    } else if (disabled && !input?.value) {
      return "NA";
    }
    return input?.value;
  };

  const renderIconInput = () => {
    return (
      <IconField iconPosition={iconPosition}>
        <InputIcon className={`pi ${icon}`} />
        <InputText
          {...inputProps}
          id={input.name}
          required={required}
          type={type}
          disabled={disabled || readOnly}
          invalid={touched && error}
          className={`edexlms-field-input w-full ${className}`}
          placeholder={placeholder}
          onChange={handleChange} // ✅ call our handler
        />
      </IconField>
    );
  };

  const renderPasswordInput = () => {
    return (
      <Password
        {...inputProps}
        inputId={input.name}
        required={required}
        disabled={disabled || readOnly}
        className={`edexlms-field-input w-full ${className}`}
        inputStyle={{ width: "100%" }}
        placeholder={placeholder}
        toggleMask
        invalid={touched && error}
        feedback={showPasswordFeedback}
        onChange={handleChange} // ✅ call our handler
      />
    );
  };

  const renderDefaultInput = () => {
    const value = getValue();
    return (
      <InputText
        {...inputProps}
        id={input.name}
        value={type==="time" && rest?.timeValue ? rest?.timeValue:value}
        required={required}
        type={disabled ? "text" : type}
        disabled={disabled || readOnly}
        invalid={touched && error}
        className={`edexlms-field-input w-full ${className}`}
        placeholder={placeholder}
        onChange={handleChange} // ✅ call our handler
        {...rest} // ✅ ensures step="1" and other props get passed
      />
    );
  };

  return (
    <div
      data-testid={`field-${input.name}`}
      className={`edexlms-field text-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
          infoMessage={infoMessage}
          infoPosition={infoPosition}
        />
      )) ||
        null}
      {(icon && !disabled && renderIconInput()) || null}
      {(type === "password" && !disabled && renderPasswordInput()) || null}
      {(((type !== "password" && !icon) || disabled) && renderDefaultInput()) ||
        null}
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, input, rest, label || placeholder)}
        </div>
      )) ||
        null}
    </div>
  );
};

TextInput.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  showPasswordFeedback: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  infoMessage: PropTypes.string,
  infoPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  onChange: PropTypes.func, // ✅ added prop type
};

export default TextInput;
